import {useEffect, useState} from 'react';
import axios from 'axios';
import {GET_WEB} from "../../../../../../constants/api.constants";
import {getAppLang, getProperty, isDefined} from "../../../../../../utils";

// SSS servisleri property_web_id ister; tesisin aktif web kaydini getirip id'sini doner.
// (Blog / Popup / Meta Tag sayfalarindaki GET_WEB cagrisinin ortak hali.)
export default function useWebId() {
    const [propertyWebId, setPropertyWebId] = useState(null);
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        const params = {params: {property_id: getProperty()}};

        axios.post(GET_WEB, params, {
            headers: {
                "Accept": "application/json",
                authToken: localStorage.getItem('auth'),
                "Content-Type": "application/json",
                "language": getAppLang(),
            }
        }).then((result) => {
            if (isDefined(result?.data?.data?.status)) {
                setPropertyWebId(result.data.data.id);
            } else {
                setPropertyWebId(null);
            }
            setFetching(false);
        }).catch(() => {
            setPropertyWebId(null);
            setFetching(false);
        });
    }, []);

    return {propertyWebId, fetching};
}
